import 'rxjs/Rx';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { UrlMaker } from 'src/app/commons/url-maker';
import { environment } from 'src/environments/environment';
import { OperationResult } from '@tb/auth';
import { Observable } from 'rxjs/Rx';
import { throwError } from 'rxjs';
import { ServiceUtilsService } from './service-utils.service';
import { catchError } from 'rxjs/operators';
import { CuSubscriptionSlots } from 'src/app/model/TimeSlots';

@Injectable({
    providedIn: 'root',
})
export class IupService {
    constructor(private http: HttpClient, private serviceUtilsService: ServiceUtilsService) {}

    getTimeSlotsReactive(subscriptionkey: string): Observable<OperationResult> {
        const authorizationHeader = this.serviceUtilsService.CreateAuthorizationHeader('jwt');
        if (authorizationHeader === '') {
            return throwError('AuthorizationHeader is missing!');
        }
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: authorizationHeader });
        const url = new UrlMaker()
            .appendBaseUrl(environment.settings.storeApiUrl)
            .appendSegment('timeslots')
            .appendSegment(subscriptionkey)
            .toString();
        return this.http
            .get<OperationResult>(url, { headers: headers })
            .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'server error (getTimeSlotsReactive)')));
    }

    getSubscriptionSlotReactive(subscriptionkey: string, proposeSize?: boolean): Observable<OperationResult> {
        const authorizationHeader = this.serviceUtilsService.CreateAuthorizationHeader('jwt');
        if (authorizationHeader === '') {
            return throwError('AuthorizationHeader is missing!');
        }
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: authorizationHeader });
        const url = new UrlMaker()
            .appendBaseUrl(environment.settings.storeApiUrl)
            .appendSegment('subscriptionslots')
            .appendSegment(subscriptionkey)
            .appendParameter('proposeSize', proposeSize)
            .toString();
        return this.http
            .get<OperationResult>(url, { headers: headers })
            .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'server error (getSubscriptionSlotReactive)')));
    }

    getCalendarJobs(subscriptionkey: string): Observable<OperationResult> {
        const authorizationHeader = this.serviceUtilsService.CreateAuthorizationHeader('jwt');
        if (authorizationHeader === '') {
            return throwError('AuthorizationHeader is missing!');
        }
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: authorizationHeader });
        const url = new UrlMaker()
            .appendBaseUrl(environment.settings.storeApiUrl)
            .appendSegment('calendarjobs')
            .appendSegment(subscriptionkey)
            .toString();
        return this.http
            .get<OperationResult>(url, { headers: headers })
            .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'server error (getCalendarJobs)')));
    }

    saveTimeSlotsReactive(body: CuSubscriptionSlots): Observable<OperationResult> {
        const authorizationHeader = this.serviceUtilsService.CreateAuthorizationHeader('jwt');
        if (authorizationHeader === '') {
            return throwError('AuthorizationHeader is missing!');
        }
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: authorizationHeader });
        const url = new UrlMaker().appendBaseUrl(environment.settings.storeApiUrl).appendSegment('subscriptionslots').toString();
        return this.http
            .post<OperationResult>(url, body, { headers: headers })
            .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'server error (saveTimeSlotsReactive)')));
    }
}
